import { motion } from "framer-motion";
import { Share2, Users, FileCheck2, ArrowUpRight } from "lucide-react";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const steps = [
  {
    icon: Share2,
    day: "Day 1",
    title: "You Share What Exists",
    body: "You share your current marketing systems, collaterals, campaigns, learner segments, and growth goals.",
  },
  {
    icon: Users,
    day: "Day 2",
    title: "We Hear the Team",
    body: "We speak with your team to learn what's working, what feels stuck, and what goals are coming next.",
  },
  {
    icon: FileCheck2,
    day: "Day 3",
    title: "We Tell You Straight",
    body: "We share a clear growth perspective — plus a limited-access playbook if we believe we can help.",
  },
];

export const Process = () => {
  return (
    <section id="process" className="bg-[#FAF7F2] text-[#1A2238] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="max-w-3xl mx-auto text-center">
          <motion.p variants={fadeUp} className="eyebrow text-[#FF6A3D] mb-6">
            The Process
          </motion.p>
          <motion.h2 variants={fadeUp} className="font-display text-4xl sm:text-5xl font-extrabold tracking-tighter leading-[1.05]">
            A 3-Day Growth Activation for Education Brands
          </motion.h2>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="mt-16 lg:mt-20 grid md:grid-cols-3 gap-12 lg:gap-10"
        >
          {steps.map((s) => {
            const Icon = s.icon;
            return (
              <motion.div
                variants={fadeUp}
                key={s.day}
                data-testid={`process-${s.day.replace(" ", "-").toLowerCase()}`}
                className="relative flex flex-col items-center text-center px-2"
              >
                <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#FF6A3D]">
                  <Icon size={26} className="text-[#1A2238]" />
                </span>
                <div className="eyebrow text-[#FF6A3D] mt-6 mb-2">{s.day}</div>
                <h3 className="font-display text-2xl font-bold tracking-tight whitespace-nowrap">{s.title}</h3>
                <p className="mt-3 text-[15px] text-[#1A2238]/60 leading-relaxed max-w-xs">{s.body}</p>
              </motion.div>
            );
          })}
        </motion.div>

        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="mt-16 flex justify-center">
          <a
            href="#contact"
            data-testid="process-cta"
            className="group inline-flex items-center gap-3 bg-[#FF6A3D] text-[#FAF7F2] font-bold text-base py-2 pl-8 pr-2 rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_36px_rgba(255,106,61,0.45)]"
          >
            Activate Now
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#1A2238] text-[#FAF7F2] transition-transform duration-300 group-hover:rotate-45">
              <ArrowUpRight size={20} />
            </span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};
